import { useMemo, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Box, Button, Typography } from "@mui/material";
import DataIngestionModal from "./components/DataIngestionModal";
import DataIngestionAfricanModal from "./components/DataIngestionAfricanModal";

export default function ClientCasePage() {
  const { caseId } = useParams();

  const [openIngestion, setOpenIngestion] = useState(false);
  useEffect(() => {
    setOpenIngestion(false);
  }, [caseId]);

  // Map each case to its live URL (same ones you already use)
  const cases = useMemo(
    () => ({
      pension: {
        title: "Pension Fund",
        liveUrl: "http://ryseagent.com/RyseServerProject_PensionFd/index.html"
      },
      "African-Soc-Sec_Fund": {
        title: "African Soc. Sec. Fund",
        liveUrl: "http://ryseagent.com/NSSF/index.html"
      },
      "family-office": {
        title: "Family Office",
        liveUrl: "http://ryseagent.com/RyseServerProjectFLyOffice/index.html"
      },
      "private-equity": {
        title: "Private Equity Fund",
        liveUrl: "http://ryseagent.com/RyseServerProj_PEFd/index.html"
      },
      crypto: {
        title: "Crypto Fund",
        liveUrl: "http://ryseagent.com/RyseServerProj_CryptoFd/index.html"
      },
      individual: {
        title: "Individual",
        liveUrl: "http://ryseagent.com/RyseServerProj_Individual/index.html"
      },
      "Middle-Income": {
        title: "Middle Income User",
        liveUrl: "http://ryseagent.com/RyseServerProject_Personal/index.html"
      }
    }),
    []
  );

  const current = cases[caseId];

  if (!current) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography variant="h6">Client case not found.</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" sx={{ fontWeight: 700, mb: 2 }}>
        {current.title}
      </Typography>

      <Typography sx={{ mb: 3 }}>
        Explore how this implementation works — from ingestion to analytics and AI reasoning.
      </Typography>

      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 2 }}>
        <Button variant="contained" onClick={() => setOpenIngestion(true)}>
          Data Ingestion
        </Button>

        <Button variant="outlined" disabled>
          Quant Analytics (next)
        </Button>

        <Button variant="outlined" disabled>
          AI Reasoning (next)
        </Button>

        <Button
          variant="outlined"
          onClick={() => window.open(current.liveUrl, "_blank", "noopener,noreferrer")}
        >
          Live Instance
        </Button>
      </Box>

      {/* Ingestion modals by client case */}
      <DataIngestionModal
        open={openIngestion && caseId === "pension"}
        onClose={() => setOpenIngestion(false)}
      />
      <DataIngestionAfricanModal
        open={openIngestion && caseId === "African-Soc-Sec_Fund"}
        onClose={() => setOpenIngestion(false)}
      />
    </Box>
  );
}
